import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type CreateRfqCrrespondenceParamsDTO = {
  uuid: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqCorrespondenceCreateMutation = () =>
  useMutation<unknown, ErrorDTO, CreateRfqCrrespondenceParamsDTO>({
    mutationFn: async (values: CreateRfqCrrespondenceParamsDTO) => {
      try {
        const res = await client.post<ApiResponseDTO>(
          `/rfq/correspondence/create/${values.uuid}`
        )

        // toast.success('Supplier profile is updated')

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
